export const STANDARD_STRAP_SIZE_SLUG = 'standard';
export enum ProductAttributesSlugs {
  WbrCurrentSize = 'wbr-current-size',
}

export const STRAP_STANDARD_SIZE_ATTRIBUTE = {
  slug: ProductAttributesSlugs.WbrCurrentSize,
  values: [STANDARD_STRAP_SIZE_SLUG],
};
